var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33104 8.52958C9.46214 5.57477 14.5386 5.57477 17.6698 8.52958L18.0466 8.88519C18.2031 9.03295 18.2031 9.27247 18.0466 9.42022L16.7575 10.6367C16.6792 10.7106 16.5523 10.7106 16.474 10.6367L15.9555 10.1474C13.7711 8.08599 10.2296 8.08599 8.04529 10.1474L7.48994 10.6714C7.41169 10.7453 7.28479 10.7453 7.20649 10.6714L5.91744 9.45492C5.76084 9.30716 5.76084 9.06765 5.91744 8.91989L6.33104 8.52958ZM20.3357 11.0454L21.483 12.1281C21.6395 12.2758 21.6395 12.5154 21.483 12.6631L16.3098 17.5451C16.1533 17.6928 15.8994 17.6928 15.7429 17.5451L12.0713 14.0802C12.0321 14.0433 11.9687 14.0433 11.9295 14.0802L8.25804 17.5451C8.10149 17.6928 7.84764 17.6928 7.69109 17.5451L2.51781 12.6631C2.36125 12.5153 2.36125 12.2758 2.51781 12.128L3.66509 11.0453C3.82164 10.8976 4.07547 10.8976 4.23203 11.0453L7.90369 14.5102C7.94279 14.5472 8.00624 14.5472 8.04539 14.5102L11.7168 11.0453C11.8734 10.8976 12.1272 10.8976 12.2838 11.0453L15.9554 14.5102C15.9946 14.5472 16.058 14.5472 16.0972 14.5102L19.7687 11.0454C19.9253 10.8977 20.1791 10.8977 20.3357 11.0454Z",
    fill: "#3396FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletconnect);
export default __webpack_public_path__ + "static/media/icon-walletconnect.8cbdbf965c17cf3298abfea13ba9bc47.svg";
export { ForwardRef as ReactComponent };